import { daoPut } from 'mrf/Dao';
import dateTimeFormatter from 'mrf/utils/DateTimeFormatter';
import ButtonIcon from 'mrf/view/ButtonIcon';
import ListCRUD from 'mrf/view/ListCRUD';
import React from 'react';
import notification, {TYPE} from "mrf/utils/notification";
import roles from "role";
import { KeyOffIcon } from 'styles/components/Icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function PublicKeyList({match}) {

    const {t} = useTranslation();

    const [reloadKey, setReloadKey] = useState(0);

    const handleRevokePublicKey = async (id) => {
        try {
            await daoPut(`/api/communicationPublicKeys/revoke/${id}`);
            notification({type: TYPE.SUCCESS, message: t('Successfully revoked public key')});
            setReloadKey(prev => prev + 1);
        } catch (error) {
            console.error('Error while trying to revoke public key:', error);
        }
    };

    const fields = [
        {name: t('Key Id'), key: 'keyId'},
        {name: t('Country'), key: 'countryName'},
        {name: t('Purpose'), key: 'purpose'},
        {name: t('Creation timestamp'), key: 'creationTimestamp', map: dateTimeFormatter},
        {name: t('Expiration timestamp'), key: 'expirationTimestamp', map: dateTimeFormatter},
        {name: t('User'), key: 'recordUserName'},
        {name: t('Status'), key: 'status', map:t},
        {
            map: (obj) => String(obj.status).trim() === 'Valid' ? (
              <ButtonIcon
                size={8}
                icon={KeyOffIcon}
                tooltip={t('Revoke Public Key')}
                onClick={() => handleRevokePublicKey(obj.id)}
                className="hover:bg-transparent hover:text-indigo-800"
              />
            ) : null,
            align: 'right'
        }
    ];

    return (
        <ListCRUD
            key={reloadKey}
            plural='communicationPublicKeys'
            singular='communicationPublicKey'
            fields={fields}
            match={match}
            disableViewButton
            canEdit={roles.ADMIN}
        />
    );
};